import ConversationAssignmentsAPI from '../../api/conversationAssignments';

export const state = {
  records: {},
  metaByConversation: {},
  uiFlags: {},
};

export const getters = {
  getAssignments:
    $state =>
    conversationId =>
      $state.records[conversationId] || [],
  getAssignmentsMeta:
    $state =>
    conversationId =>
      $state.metaByConversation[conversationId] || {},
  getUIFlags:
    $state =>
    conversationId =>
      $state.uiFlags[conversationId] || { isFetching: false },
};

export const actions = {
  async fetch({ commit }, conversationId) {
    if (!conversationId) {
      return { payload: [], meta: {} };
    }

    commit('setUIFlags', { conversationId, flags: { isFetching: true } });
    try {
      const response = await ConversationAssignmentsAPI.getAssignments(conversationId);
      commit('setAssignments', {
        conversationId,
        payload: response.data?.payload || [],
        meta: response.data?.meta || {},
      });
      return response.data;
    } finally {
      commit('setUIFlags', { conversationId, flags: { isFetching: false } });
    }
  },
};

export const mutations = {
  setAssignments($state, { conversationId, payload, meta }) {
    $state.records = {
      ...$state.records,
      [conversationId]: payload,
    };
    $state.metaByConversation = {
      ...$state.metaByConversation,
      [conversationId]: meta,
    };
  },

  setUIFlags($state, { conversationId, flags }) {
    $state.uiFlags = {
      ...$state.uiFlags,
      [conversationId]: {
        ...($state.uiFlags[conversationId] || {}),
        ...flags,
      },
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
